import axios from "axios";
import Cookies from "js-cookie";

const headers = {
    "Accept": "application/json",
    "Content-Type": "application/json",
};

const responseErrorHandler = async (error: any) => {
    if (error?.response?.status === 401) {
        if (localStorage !== null) {
            localStorage.removeItem('@beviAjudaGui:user');
        }
        return (
            window.location.pathname !== `/` && (window.location.href = `/`)
        );
    }

    if (error?.response?.status === 403 && !error?.config?.skipAuthRedirect) {
        const errorMessage = error.response.data.message || "Acesso não autorizado.";
        sessionStorage.setItem("unauthorizedMessage", errorMessage);

        return (
            window.location.pathname !== `/unauthorized` && (window.location.href = `/unauthorized`)
        );
    }

    if (error?.response?.status === 503) {
        const errorMessage = error.response.data.message || "Servidor em Manutenção.";
        sessionStorage.setItem("maintenanceMessage", errorMessage);

        return (
            window.location.pathname !== `/maintenance` && (window.location.href = `/maintenance`)
        );
    }

    return Promise.reject(error);
};

const api = axios.create({
    baseURL: process.env.REACT_APP_BEVIAJUDA_API,
    headers: headers,
    withCredentials: true,
});

api.interceptors.request.use(
    async (request) => {
        let token;
        token = (await localStorage.getItem("@beviAjudaGui:auth")) || "";

        if (token && token !== 'undefined') {
            token = JSON.parse(token);

            if (request.headers && !request.headers?.Authorization) {
                request.headers.Authorization = `Bearer ${token}`;
            }
        }

        // Se for FormData, remove o Content-Type fixo para que axios configure corretamente como multipart/form-data
        if (request.data instanceof FormData) {
            delete request.headers['Content-Type'];
        }

        return request;
    },
    (error) => console.log(error)
);

api.interceptors.response.use(
    async (request) => {
        return request;
    },
    (error) => responseErrorHandler(error)
);

export default api;
